import { CopyText } from 'lib/components/CopyText';
import useAsyncEffect from 'lib/frontend/hooks/useAsyncEffect';
import { centsToDollarsString } from 'lib/helpers';
import { OrderDetailModel } from 'lib/model/objects/orderDetailModel';
import { OrderModel } from 'lib/model/objects/orderModel';
import { ColumnService } from 'lib/services/directory';
import { selectIsPublisher } from 'redux/auth';
import { useAppSelector } from 'redux/hooks';
import AdDetailsCard from 'routes/notice/AdDetailsCard';
import { AdDetailsCardRow } from './AdDetailsCardRow';
import { AdDetailsCouponsCard } from './AdDetailsCouponsCard';
import { AdDetailsSyncAttemptCard } from './AdDetailsSyncAttemptCard';

export function OrderDetailsCard({
  order,
  orderDetail
}: {
  order: OrderModel;
  orderDetail: OrderDetailModel;
}) {
  const isPublisher = useAppSelector(selectIsPublisher);

  const { value: orderDetailsDescription } = useAsyncEffect({
    fetchData: order.orderDetailsDescription,
    dependencies: [orderDetail.id],
    errorConfig: {
      service: ColumnService.ORDER_MANAGEMENT,
      message: 'Error fetching order details description',
      tags: { orderId: order.id }
    }
  });

  return (
    <AdDetailsCard
      id="order-details"
      header={{
        title:
          !isPublisher || !orderDetailsDescription ? (
            'Order Details'
          ) : (
            <CopyText copyText={orderDetailsDescription}>
              Order Details
            </CopyText>
          )
      }}
    >
      <AdDetailsCardRow
        label="Order ID"
        value={<CopyText copyText={order.id}>{order.id}</CopyText>}
      />
      <AdDetailsCardRow
        label="Price"
        value={
          orderDetail.modelData.pricing?.totalInCents !== undefined
            ? `$${centsToDollarsString(
                orderDetail.modelData.pricing?.totalInCents
              )}`
            : ''
        }
      />
      <AdDetailsCouponsCard orderDetail={orderDetail} order={order} />
      <AdDetailsSyncAttemptCard order={order} />
    </AdDetailsCard>
  );
}
